import EmailIcon from "@mui/icons-material/Email";
import FacebookIcon from "@mui/icons-material/Facebook";
import LanguageIcon from "@mui/icons-material/Language";
import LinkedinIcon from "@mui/icons-material/LinkedIn";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import TelegramIcon from "@mui/icons-material/Telegram";

export const drawerWidth = 280;

export const contact_info = [
  {
    icon: <LocalPhoneIcon />,
    text: "0963626061",
  },
  {
    icon: <EmailIcon />,
    text: "ceo@orbit.et",
  },
  {
    icon: <LanguageIcon />,
    text: "www.orbit.et",
  },
];

export const social_media_sites = [
  {
    icon: <FacebookIcon />,
    link: "https://web.facebook.com/p/Orbit-Technology-Solution-PLC-100086330515097?_rdc=1&_rdr",
  },
  {
    icon: <TelegramIcon />,
    link: "https://www.t.me/orbitet",
  },
  {
    icon: <LinkedinIcon />,
    link: "https://www.linkedin.com/company/orbitet/",
  },
];
